export const environment = {
  production: true,
  staging: false,
  appVersion: require('../../package.json').version,
  WS_PATH: 'wss://stage-api-ws.blackhawksupply.com/ws',
  API_PATH: 'https://stage-api.blackhawksupply.com'
};
